var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAssaignIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-person-profile-check-svgrepo-com_1_",
    "data-name": "user-person-profile-check-svgrepo-com (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.3,
    height: 14.3,
    viewBox: "0 0 14.3 14.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M5,5.575A3.575,3.575,0,1,1,8.575,9.15,3.575,3.575,0,0,1,5,5.575ZM8.575,3.43A2.145,2.145,0,1,0,10.72,5.575,2.145,2.145,0,0,0,8.575,3.43Z",
    transform: "translate(-2.855 -2)",
    fill: "#a5a7a7",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M3.432,18.29a2.962,2.962,0,0,1,2.96-2.86h.613a.715.715,0,1,0,0-1.43H6.392A4.392,4.392,0,0,0,2,18.392,1.328,1.328,0,0,0,3.328,19.72H7.72a.715.715,0,0,0,0-1.43Z",
    transform: "translate(-2 -5.42)",
    fill: "#a5a7a7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M15.575,19.15A3.575,3.575,0,1,0,12,15.575,3.575,3.575,0,0,0,15.575,19.15Zm.022-2.123,1.788-1.788a.536.536,0,0,0-.758-.758l-1.408,1.408-.336-.336a.536.536,0,0,0-.758.758l.715.715A.537.537,0,0,0,15.6,17.027Z",
    transform: "translate(-4.85 -4.85)",
    fill: "#a5a7a7",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAssaignIcon);
export default __webpack_public_path__ + "static/media/user-assaign-icon.d08a7559b674508a7f80ebc617bb3d47.svg";
export { ForwardRef as ReactComponent };